module.exports = __webpack_public_path__ + "img/vvip-drinknsnack-offer.c3d63076.webp";